const getCorrectedDateTime = (dateString) => {
    const dateObj = new Date(dateString);

    return new Date(dateObj.getTime() + (dateObj.getTimezoneOffset() * 60000));
}

export const getServerFormattedDate = (date) => {
    const dateObj = getCorrectedDateTime(date)

    return `${dateObj.getMonth() + 1}/${dateObj.getDate()}/${dateObj.getFullYear()}`;
};

export const getISOFormattedDate = (date) => {
    return getCorrectedDateTime(date).toISOString().substring(0, 10);
}